$(document).ready(function() {
    // Utility: Wait for a single DOM element to appear
    function waitForElm(selector) {
        return new Promise(resolve => {
            if (document.querySelector(selector)) {
                return resolve(document.querySelector(selector));
            }

            const observer = new MutationObserver(() => {
                if (document.querySelector(selector)) {
                    observer.disconnect();
                    resolve(document.querySelector(selector));
                }
            });

            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
        });
    }

    // ✅ Wait for the smile widget to load and fix z-index
    waitForElm('div#smile-ui-lite-container').then((elm) => {
        console.log('Element is ready');
        $('div#smile-ui-lite-container').css('z-index', 2147483646);
    });

    // ✅ Handle mobile menu clicks
    if ($(window).width() < 750) {
        jQuery('.main-menu .parent').on('click', function() {
            jQuery(this).find('.nav-carat')[0].click();
        });

        jQuery('.main-menu .parent .nav-carat').on('click', function() {
            jQuery(this).parent().click();
        });
    }

    // ✅ Initial scan for existing products
    var detect_all_id_product = [];
    jQuery('.product-item').each(function() {
        var code = $(this).attr("id");
        detect_all_id_product.push(code);
    });

    jQuery.each(detect_all_id_product, function(index, value) {
        var get_id_product = this;
        var get_product_by_id = jQuery('#' + get_id_product + ' .swatch-element:first-child input').attr('class');
        jQuery('#' + get_id_product + ' .product-grid-item-special-box-image .' + get_product_by_id).addClass('display-animation');
        jQuery('#' + get_id_product + ' .product-special-item-label.sale-special.' + get_product_by_id).addClass('display-animation');
        jQuery('#' + get_id_product + ' .product-special-item-label2.sold-special.' + get_product_by_id).addClass('display-animation');
        jQuery('#' + get_id_product + ' .product-special-price-var.' + get_product_by_id).addClass('display-animation');
    });

    // ✅ Utility: Wait until swatches (ul > li) are fully loaded
    function waitUntilSwatchesLoaded(selector, callback, timeout = 5000, interval = 100) {
        const startTime = Date.now();

        const checkExist = setInterval(() => {
            const $ul = jQuery(selector);
            const $li = $ul.find('> li');

            if ($ul.length > 0 && $li.length > 0) {
                clearInterval(checkExist);
                callback($li.length);
            } else if (Date.now() - startTime > timeout) {
                clearInterval(checkExist);
                console.warn('⛔ Timeout: Swatches not found for', selector);
                callback(0);
            }
        }, interval);
    }

    // ✅ MutationObserver to detect newly inserted products
    const observer = new MutationObserver(function(mutationsList) {
        var detect_all_id_product = [];

        mutationsList.forEach(function(mutation) {
            if (mutation.type === 'childList') {
                jQuery(mutation.target).find('.product-item').each(function() {
                    var code = jQuery(this).attr("id");
                    var detect_has_class = jQuery(this).hasClass("special-check-loaded");

                    if (!detect_has_class) {
                        detect_all_id_product.push(code);
                    }
                });
            }
        });

        jQuery.each(detect_all_id_product, function(index, value) {
            var get_id_product = this;
            var get_product_by_id = jQuery('#' + get_id_product + ' .swatch-element:first-child input').attr('class');

            jQuery('#' + get_id_product).addClass('special-check-loaded');
            jQuery('#' + get_id_product + ' .product-grid-item-special-box-image .' + get_product_by_id).addClass('display-animation');
            jQuery('#' + get_id_product + ' .product-special-item-label .sale-special.' + get_product_by_id).addClass('display-animation');
            jQuery('#' + get_id_product + ' .product-special-item-label2 .sold-special.' + get_product_by_id).addClass('display-animation');
            jQuery('#' + get_id_product + ' .product-special-price-var.' + get_product_by_id).addClass('display-animation');

            // ✅ Wait for swatch list with li items to load
            const swatchSelector = '#' + get_id_product + ' ul.swatch-view';

            setTimeout(function() {
                console.log(`⏳ Initializing Swiper for Product ID: ${get_id_product}`);
                new Swiper(`.swiper-${get_id_product}`, {
                    loop: true,
                    navigation: {
                        nextEl: `.swiper-button-next-${get_id_product}`,
                        prevEl: `.swiper-button-prev-${get_id_product}`,
                    },
                });
            }, 1000);

            waitUntilSwatchesLoaded(swatchSelector, function(liCount) {
                // console.log(`✅ Product ID: ${get_id_product}, Swatch Count: ${liCount}`);
                jQuery('#' + get_id_product + ' .swatch-count').remove();

                jQuery('#' + get_id_product + ' .product-special-swatch-count')
                    .append('<div class="swatch-count" style="font-size:12px;">+' + liCount + ' COLORS</div>');
            });
        });
    });

    observer.observe(document.body, { childList: true, subtree: true });

    // ✅ Swatch change handler
    $('body').on('click', '.swatch-element input', function() {
        var get_color_product = jQuery(this).attr('class');
        var get_model_product = get_color_product + '-model';
        var get_id_product = jQuery(this).closest(".product-item").attr('id');
        var get_id_product2 = jQuery(this).closest(".product-link").attr('id');
        var change_link_href = $('#' + get_id_product + ' .triger_link_var .' + get_color_product).html();

        if (typeof change_link_href !== 'undefined') {
            var parts = change_link_href.split('?');
            if (parts.length > 2) {
                var new_parts = parts[0] + '?' + parts[2];
                $('#' + get_id_product + ' a').attr("href", new_parts);
            } else {
                $('#' + get_id_product + ' a').attr("href", change_link_href);
            }
        }

        $('#' + get_id_product + ' .product-special-price-var').removeClass('display-animation');
        $('#' + get_id_product + ' .product-grid-item-special-box-image img').removeClass('display-animation');
        $('#' + get_id_product + ' .product-special-item-label .sale-special').removeClass('display-animation');
        $('#' + get_id_product + ' .product-special-item-label2 .sold-special').removeClass('display-animation');

        $('#' + get_id_product + ' .product-grid-item-special-box-image .' + get_color_product).addClass('display-animation');
        $('#' + get_id_product + ' .product-special-item-label .' + get_color_product).addClass('display-animation');
        $('#' + get_id_product + ' .product-special-item-label2 .sold-special.' + get_color_product).addClass('display-animation');
        $('#' + get_id_product + ' .product-special-price-var.' + get_color_product).addClass('display-animation');
    });
});